export default "__VITE_ASSET__0aaaf078__"